<template>
  <div class="container-fluid">
    <net-pa-card>
      <template slot="header">
        <h6 class="text-right">
          <i class="fas fa-hand-holding-usd"></i> درخواست وام
          <span class="float-left" @click="$router.go(-1)"> <i data-v-9331d9a2="" title="بازگشت به صفحه قبلی"
              class="fas fa-arrow-left text-light Pointer" style="float: left; font-size: 18px"></i></span>
        </h6>
      </template>
      <template slot="content" v-if="!showGhavaninVam">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div @click="selectCurent($event, 1)"
                class="col-12 col-md-2 border current bnp-rounded text-right hoverHeader mr-1 pr-3 p-2">
                <a class="d-block w-100 h-100" id="head1"> انتخاب نوع وام</a>
              </div>
              <div @click="selectCurent($event, 2)" v-if="Object.entries(SelectedVam).length != 0"
                class="col-12 col-md-2 border bnp-rounded text-right hoverHeader mr-1 pr-3 p-2">
                <a class="d-block w-100 h-100" id="head2"> اطلاعات تکمیلی</a>
              </div>
              <div v-else class="col-12 col-md-2 border bnp-rounded text-right mr-1 pr-3 p-2">
                <a class="d-block w-100 h-100" id="head2" title="ابتدا نوع وام را مشخص کنید"> اطلاعات تکمیلی</a>
              </div>
              <div v-if="vamDetail.Mablaghghest == 0 || vamDetail.MablaghVam == 0"
                class="col-12 col-md-2 border bnp-rounded text-right mr-1 pr-3 p-2">
                <a class="d-block w-100 h-100" id="head3" title="لطفا اطلاعات وام را تکمیل کنید"> مشخصات ضامنین</a>
              </div>
              <div v-else @click="selectCurent($event, 3)"
                class="col-12 col-md-2 border bnp-rounded text-right hoverHeader mr-1 pr-3 p-2">
                <a class="d-block w-100 h-100" id="head3"> مشخصات ضامنین</a>
              </div>

              <div @click="selectCurent($event, 4)"
                class="col-12 col-md-2 border bnp-rounded text-right hoverHeader mr-1 pr-3 p-2">
                <a class="d-block w-100 h-100" id="head4"> آپلود مدارک</a>
              </div>
              <div @click="selectCurent($event, 5)"
                class="col-md-3 col-12 border bnp-rounded text-right hoverHeader mr-1 pr-3 p-2">
                <a class="d-block w-100 h-100" id="head5"> تایید نهایی</a>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3 px-2">
          <div v-if="divToShow == 1" class="col-12 border bnp-rounded">
            <div v-for="(item, key) in Vamha" :key="key" class="row px-3">
              <div class="col-3"></div>
              <div class="col-12 col-md-6 mt-2 p-2">
                <div class="w-100 border bnp-rounded Netpa-Shadow p-2">
                  <div class="row">
                    <div class="col-6 text-right">
                      <span class="text-secondary">نام تسهیلات: </span>
                      <span class="text-dark font-weight-bold">{{ item.desNoe }}</span>
                    </div>

                    <div class="col-6 text-left">
                      <button v-if="SelectedVam.id != item.id" @click="seLectVam(item)"
                        class="btn NetPa-btn btn-primary">انتخاب</button>
                      <span v-else class="text-success font-weight-bold"> انتخاب شده <i class="fas fa-check"></i></span>
                    </div>
                    <div class="col-12 mt-1 text-right">
                      <span class="text-secondary">{{ item.tozihatForRequestVam }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-3"></div>
            </div>
            <div class="row my-2 px-3">
              <div class="col-3"></div>
              <div class="col-3"></div>
              <div class="col-3"></div>
              <div class="col-12 col-md-3">
                <button :disabled="Object.entries(SelectedVam).length === 0" @click="nextPage(2)"
                  class="btn btn-success w-100 NetPa-btn">مرحله بعد</button>
              </div>
            </div>
          </div>
          <div v-if="divToShow == 2" class="col-12 border bnp-rounded">
            <div class="row">
              <div class="col-3"></div>
              <div class="col-md-6 col-12 row">
                <div class="col-md-6 py-2 col-12">
                  <label for="MabVam" class="text-secondary"> مبلغ وام</label>
                  <input type="text" :disabled="SelectedVam.fixMablagh" id="MabVam"
                    class="form-control text-left 3ragham" v-model="vamDetail.MablaghVam" @keyup="
            $PutCommatoInput()
          calculateMablaghghest()
          CheckupSaghfVam($event)
            " @keypress="$ValidNumber($event, 15, false)" dir="ltr" />
                </div>
                <div class="col-md-6 py-2 col-12">
                  <span class="text-secondary text-weight-normal">تاریخ نیاز</span>
                  <date-picker :disabled="$session.get('CustCode') == 868" v-model="vamDetail.NeedData"
                    color="#f38905"></date-picker>
                  <input type="text" id="NeedData" v-model="vamDetail.NeedData" class="d-none InputText" dir="ltr" />
                </div>
                <div class="col-md-6 py-2 col-12">
                  <label for="ghestNum" class="text-secondary"> تعداد قسط</label>
                  <input v-if="$session.get('CustCode') != 868" type="text" @keyup="calculateMablaghghest"
                    :disabled="SelectedVam.fixTedad" id="ghestNum" v-model="vamDetail.TedadGhest"
                    class="form-control text-left" maxlength="2" @keypress="$ValidNumber($event, 12, false)"
                    dir="ltr" />

                  <select v-else class="form-control text-center" v-model="vamDetail.TedadGhest"
                    @change="calculateMablaghghest($event)">
                    <option :value="24">24</option>
                    <option :value="36">36</option>
                    <option :value="48">48</option>
                  </select>
                </div>
                <div class="col-md-6 py-2 col-12" v-if="this.$session.get('CustCode') != 9">
                  <label for="ghestmab" class="text-secondary"> مبلغ قسط</label>
                  <input disabled="disabled" type="text" id="ghestmab" v-model="vamDetail.Mablaghghest"
                    class="form-control text-left 3ragham" />
                </div>
                <div class="col-md-6 py-2 col-12"
                  v-if="$session.get('CustCode') != 868 && $session.get('CustCode') != 8002">
                  <label class="text-secondary"> نحوه پرداخت وام</label>
                  <select v-model="nahvepardakht" class="form-control Pointer">
                    <option value="4014">واریز به حساب بانکی</option>
                    <option selected value="4015">واریز به حساب پس انداز</option>
                  </select>
                </div>
                <div class="col-md-6 py-2 col-12"
                  v-if="$session.get('CustCode') != 868 && $session.get('CustCode') != 8002">
                  <span v-if="nahvepardakht == 4015">
                    <label class="text-secondary">انتخاب حساب پس انداز </label>
                    <select class="form-control Pointer" v-model="NahveVarizDetail">
                      <option v-for="item in ListTaahodat" :key="item.id" :value="item.id">{{ item.desNoe }}</option>
                    </select>
                  </span>
                  <span v-if="nahvepardakht == 4014">
                    <label class="text-secondary">انتخاب حساب بانکی </label>
                    <select class="form-control Pointer" v-model="NahveVarizDetail">
                      <option v-for="item in ListAzaHesab" :key="item.id" :value="item.id">{{ item.bankName }} -- {{
            item.hesabNo }}</option>
                    </select>
                  </span>
                </div>
              </div>
              <div class="col-3"></div>
            </div>
            <div class="row mb-2">
              <div class="col-3"></div>
              <div class="col-3"></div>
              <div class="col-3"></div>
              <div class="col-12 col-md-3">
                <button :disabled="vamDetail.Mablaghghest == 0 || vamDetail.MablaghVam == 0" @click="nextPage(3)"
                  class="btn btn-success my-2 w-100 NetPa-btn">مرحله بعد</button>
              </div>
            </div>
          </div>
          <div v-if="divToShow == 3" class="col-12 border bnp-rounded">
            <div class="row">
              <div class="col-3"></div>
              <div class="col-12 col-md-6">
                <div class="col-12 row my-3">
                  <div class="col-12 col-md-1"></div>
                  <div class="col-10 col-md-8">
                    <input type="number" class="form-control text-left" v-model="ListCodeMeli[0]"
                      placeholder="کدملی ضامن اول" />
                  </div>
                  <div class="col-2 col-md-2">
                    <button class="btn btn-success" @click="GetZament(0)">بررسی</button>
                    <button class="d-none" id="ZamenModal" data-toggle="modal"
                      data-target="#Modal-Orange">modal</button>
                  </div>
                  <div class="col-12 col-md-1"></div>
                  <div class="col-12 col-md-1"></div>
                  <div v-if="ListZamen[0].NameFamily != ''"
                    class="col-10 col-md-10 my-2 border border-success rounded p-2">
                    <div class="w-100">
                      <span class="text-secondary">نام ضامن:</span>
                      <span class="text-dark">
                        {{ ListZamen[0].NameFamily }}
                      </span>
                    </div>
                  </div>
                  <div class="col-12 col-md-1"></div>
                </div>

                <div class="col-12 row my-3">
                  <div class="col-12 col-md-1"></div>
                  <div class="col-10 col-md-8">
                    <input type="number" class="form-control text-left" v-model="ListCodeMeli[1]"
                      placeholder="کدملی ضامن دوم" />
                  </div>
                  <div class="col-2 col-md-2">
                    <button class="btn btn-success" @click="GetZament(1)">بررسی</button>
                    <button class="d-none" id="ZamenModal" data-toggle="modal"
                      data-target="#Modal-Orange">modal</button>
                  </div>
                  <div class="col-12 col=md-1"></div>
                  <div class="col-12 col-md-1"></div>
                  <div v-if="ListZamen[1].NameFamily != ''"
                    class="col-10 col-md-10 my-2 border border-success rounded p-2">
                    <div class="w-100">
                      <span class="text-secondary">نام ضامن:</span>
                      <span class="text-dark">
                        {{ ListZamen[1].NameFamily }}
                      </span>
                    </div>
                  </div>
                  <div class="col-12 col=md-1"></div>
                </div>

                <div class="col-12 row my-3">
                  <div class="col-12 col-md-1"></div>
                  <div class="col-10 col-md-8">
                    <input type="number" class="form-control text-left" v-model="ListCodeMeli[2]"
                      placeholder="کدملی ضامن سوم" />
                  </div>
                  <div class="col-2 col-md-2">
                    <button class="btn btn-success" @click="GetZament(2)">بررسی</button>
                    <button class="d-none" id="ZamenModal" data-toggle="modal"
                      data-target="#Modal-Orange">modal</button>
                  </div>
                  <div class="col-12 col=md-1"></div>
                  <div class="col-12 col-md-1"></div>
                  <div v-if="ListZamen[2].NameFamily != ''"
                    class="col-10 col-md-10 my-2 border border-success rounded p-2">
                    <div class="w-100">
                      <span class="text-secondary">نام ضامن:</span>
                      <span class="text-dark">
                        {{ ListZamen[2].NameFamily }}
                      </span>
                    </div>
                  </div>
                  <div class="col-12 col=md-1"></div>
                </div>
              </div>
              <div class="col-3"></div>
            </div>
            <div class="row mb-2">
              <div class="col-3"></div>
              <div class="col-3"></div>
              <div class="col-3"></div>
              <div class="col-12 col-md-3">
                <button :disabled="vamDetail.Mablaghghest == 0 || vamDetail.MablaghVam == 0" @click="nextPage(4)"
                  class="btn btn-success my-2 w-100 NetPa-btn">مرحله بعد</button>
              </div>
            </div>
          </div>
          <div v-if="divToShow == 4" class="col-12 border bnp-rounded">
            <div class="row">
              <div class="col-md-3"></div>
              <div class="col-md-6 col-12 p-4 row">
                <div class="col-12" v-if="$session.get('CustCode') != 868">
                  <div v-if="$cookies.isKey('DownloadForm')" class="w-100 p-4 row yellowback mb-2 text-center"
                    style="height: 10vh">
                    <h6>
                      برای دانلود فرم درخواست وام <a :href="$cookies.get('DownloadForm')" download="فرم درخواست وام">
                        <sapn class="badge badge-success">اینجا</sapn>
                      </a> کلیک کنید.
                    </h6>
                  </div>
                </div>
                <div class="col-12" v-if="$session.get('CustCode') != 868">
                  <div class="w-100 p-4 row border-dotted blueback" style="height: 25vh">
                    <div class="col-6 h-100">
                      <input type="file" id="attachmentUploader" @change="changeattach($event)" class="d-none" accept=".gif,.jpg,.jpeg,.png,.zip,.rar,.pdf" />
                      <button class="btn btn-primary m-4 Netpa-btn" @click="clickUploader" style="margin: auto">بارگذاری
                        فایل</button>
                    </div>
                    <div class="col-6 row h-100">
                      <div class="col-12 text-center">
                        <span>
                          <i class="fas fa-file text-primary" style="font-size: 50px !important"></i>
                        </span>
                      </div>
                      <span v-if="attachment">
                        <div class="col-12">
                          <span class="text-secondary my-3">نام فایل:</span>
                          <span class="text-dark">{{ attachment.name }}</span>
                        </div>
                        <div class="col-12 my-3">
                          <span class="text-secondary">حجم فایل:</span>
                          <span class="text-dark"> KB {{ attachment.size / 1000 }} </span>
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-12" v-else>
                  <div class="row">
                    <!-- <div class="col-12">
                      <div class="alert alert-secondary text-center">لطفا مدارک خواسته شده را آپلود نمایید و سپس روی دکمه مرحله بعد کلیک نمایید</div>
                    </div> -->
                    <div class="col-md-4 col-12">
                      <div class="Uploader Pointer text-center py-3 px-3" @click="OpenUploader(1)">
                        <i class="fa fa-file-import fa-5x text-logo mt-3"></i>
                        <div class="mt-5" v-if="!FileHokm868">فایل <span class="text-warning"> حکم کارگزینی وام گیرنده و
                            ضامن</span> خود را بارگذاری کنید</div>
                        <div class="mt-5 m" v-else>
                          فایل <span class="text-warning">{{ FileHokm868.name }}</span> بارگذاری شد
                        </div>
                        <!-- <small class="text-warning" v-if="!FileHokm868">( کلیک کنید )</small>
                        <small class="text-dark " v-else><i class="fa fa-trash hover-danger mt-3 fa-2x mx-3" title="حذف فایل"></i><i class="fa fa-upload hover-info mt-3 fa-2x mx-3" title="آپلود مجدد فایل"></i></small> -->
                      </div>
                      <input type="file" class="form-control d-none" id="FileHokm" accept=".gif,.jpg,.jpeg,.png,.zip,.rar,.pdf"
                        @change="UploadFile($event, 1, 'FileHokm')" />
                    </div>
                    <div class="col-md-4 col-12">
                      <div class="Uploader Pointer text-center py-3 px-3" @click="OpenUploader(2)">
                        <i class="fa fa-file-import fa-5x text-logo mt-3"></i>
                        <div class="mt-5" v-if="!FileZamenanat868">فایل <span class="text-warning"> فرم ضمــانت </span>
                          خود را بارگذاری کنید</div>
                        <div class="mt-5 m" v-else>
                          فایل <span class="text-warning">{{ FileZamenanat868.name }}</span> بارگذاری شد
                        </div>
                        <!-- <small class="text-warning" v-if="!FileZamenanat868">( کلیک کنید )</small>
                        <small class="text-dark " v-else><i class="fa fa-trash hover-danger mt-3 fa-2x mx-3" title="حذف فایل"></i><i class="fa fa-upload hover-info mt-3 fa-2x mx-3" title="آپلود مجدد فایل"></i></small> -->
                      </div>
                      <input type="file" class="form-control d-none" id="FileZemanat" accept=".gif,.jpg,.jpeg,.png,.zip,.rar,.pdf"
                        @change="UploadFile($event, 2, 'FileZemanat')" />
                    </div>
                    <div class="col-md-4 col-12">
                      <div class="Uploader Pointer text-center py-3 px-3" @click="OpenUploader(3)">
                        <i class="fa fa-file-import fa-5x text-logo mt-3"></i>
                        <div class="mt-5" v-if="!FileGhardad868">فایل <span class="text-warning"> قرارداد وام </span>
                          خود را بارگذاری کنید</div>
                        <div class="mt-5 m" v-else>
                          فایل <span class="text-warning">{{ FileGhardad868.name }}</span> بارگذاری شد
                        </div>
                        <!-- <small class="text-warning" v-if="!FileGhardad868">( کلیک کنید )</small>
                        <small class="text-dark " v-else><i class="fa fa-trash hover-danger mt-3 fa-2x mx-3" title="حذف فایل"></i><i class="fa fa-upload hover-info mt-3 fa-2x mx-3" title="آپلود مجدد فایل"></i></small> -->
                      </div>
                      <input type="file" class="form-control d-none" id="FileGhrardad" accept=".gif,.jpg,.jpeg,.png,.zip,.rar,.pdf"
                        @change="UploadFile($event, 3, 'FileGhrardad')" />
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-3"></div>
            </div>
            <div class="row mb-2">
              <div class="col-3"></div>
              <div class="col-3"></div>
              <div class="col-3"></div>
              <div class="col-12 col-md-3">
                <button @click="nextPage(5)" class="btn btn-success my-2 w-100 NetPa-btn">مرحله بعد</button>
              </div>
            </div>
          </div>
          <div v-if="divToShow == 5" class="col-12 border bnp-rounded">
            <div class="w-100 p-2">
              <h4 style="font-size: 15px" class="font-weight-bold">تایید نهایی درخواست</h4>
              <hr />
            </div>
            <div class="row border-right border-primary my-1 mx-3" style="border-right: 3px solid #007bff !important">
              <div class="col-12 m-2 border-bottom">
                <h6>مشخصات وام</h6>
              </div>
              <div class="col-md-6 col-12 my-1">
                <span class="text-secondary font-weight-bold"> نام تسهیلات درخواستی:</span>
                <span class="text-dark"> {{ SelectedVam.desNoe }} </span>
              </div>
              <div class="col-md-6 col-12 my-1">
                <span class="text-secondary font-weight-bold"> مبلغ درخواستی :</span>
                <span class="text-dark"> {{ $Comma3ragham(vamDetail.MablaghVam) }} {{ $GetVahedPool()
                  }}</span>
              </div>
              <div class="col-md-6 col-12 my-1" v-if="this.$session.get('CustCode') != 9">
                <span class="text-secondary font-weight-bold"> مبلغ هر قسط :</span>
                <span class="text-dark"> {{ $Comma3ragham(vamDetail.Mablaghghest) }} {{ $GetVahedPool()
                  }}</span>
              </div>
              <div class="col-md-6 col-12 my-1">
                <span class="text-secondary font-weight-bold"> تعداد قسط :</span>
                <span class="text-dark"> {{ vamDetail.TedadGhest }} </span>
              </div>
              <div class="col-md-6 col-12 my-1">
                <span class="text-secondary font-weight-bold"> تاریخ نیاز وام:</span>
                <span class="text-dark"> {{ vamDetail.NeedData }} </span>
              </div>
            </div>
            <!-- <div class="w-100 border my-3 border-success">
              {{ ListZamen }}
            </div> -->
            <div class="row border-right border-success mt-3 mx-3" style="border-right: 3px solid #28a745 !important">
              <div class="col-12 m-2 border-bottom">
                <h6>مشخصات ضامنین</h6>
              </div>
              <div class="col-12 border rounded m-2">
                <div v-if="ListZamen[0].Id != null" class="row">
                  <div class="col-12 m-2">
                    <span class="font-weight-bold font-weight-bold">مشخصات ضامن اول</span>
                  </div>
                  <div class="col-md-4 col-12">
                    <span class="text-secondary"> نام نام خانوادگی: </span>
                    <span>{{ ListZamen[0].NameFamily }}</span>
                  </div>
                  <div class="col-md-4 col-12">
                    <span class="text-secondary font-weight-bold"> کدملی: </span>
                    <span>{{ ListZamen[0].CodeMeli }}</span>
                  </div>
                  <div class="col-md-4 col-12">
                    <span class="text-secondary font-weight-bold"> نام پدر: </span>
                    <span>{{ ListZamen[0].Pedar }}</span>
                  </div>
                  <div class="col-md-4 col-12">
                    <span class="text-secondary font-weight-bold"> شماره تماس: </span>
                    <span>{{ ListZamen[0].Tel }}</span>
                  </div>
                  <div class="col-md-4 col-12">
                    <span class="text-secondary font-weight-bold"> شماره همراه: </span>
                    <span>{{ ListZamen[0].Mobile }}</span>
                  </div>
                  <div class="colmd-6 col-12">
                    <span class="text-secondary font-weight-bold"> آدرس: </span>
                    <span>{{ ListZamen[0].Adres }}</span>
                  </div>
                </div>
                <div v-if="ListZamen[1].Id != null" class="row">
                  <div class="col-12 m-2">
                    <span class="font-weight-bold">مشخصات ضامن دوم</span>
                  </div>
                  <div class="col-md-4 col-12">
                    <span class="text-secondary"> نام نام خانوادگی: </span>
                    <span>{{ ListZamen[1].NameFamily }}</span>
                  </div>
                  <div class="col-md-4 col-12">
                    <span class="text-secondary"> کدملی: </span>
                    <span>{{ ListZamen[1].CodeMeli }}</span>
                  </div>
                  <div class="col-md-4 col-12">
                    <span class="text-secondary"> نام پدر: </span>
                    <span>{{ ListZamen[1].Pedar }}</span>
                  </div>
                  <div class="col-md-4 col-12">
                    <span class="text-secondary"> شماره تماس: </span>
                    <span>{{ ListZamen[1].Tel }}</span>
                  </div>
                  <div class="col-md-4 col-12">
                    <span class="text-secondary"> شماره همراه: </span>
                    <span>{{ ListZamen[1].Mobile }}</span>
                  </div>
                  <div class="colmd-6 col-12">
                    <span class="text-secondary"> آدرس: </span>
                    <span>{{ ListZamen[1].Adres }}</span>
                  </div>
                </div>
                <div v-if="ListZamen[2].Id != null" class="row">
                  <div class="col-12 m-2">
                    <span class="font-weight-bold">مشخصات ضامن سوم</span>
                  </div>
                  <div class="col-md-4 col-12">
                    <span class="text-secondary"> نام نام خانوادگی: </span>
                    <span>{{ ListZamen[2].NameFamily }}</span>
                  </div>
                  <div class="col-md-4 col-12">
                    <span class="text-secondary"> کدملی: </span>
                    <span>{{ ListZamen[2].CodeMeli }}</span>
                  </div>
                  <div class="col-md-4 col-12">
                    <span class="text-secondary"> نام پدر: </span>
                    <span>{{ ListZamen[2].Pedar }}</span>
                  </div>
                  <div class="col-md-4 col-12">
                    <span class="text-secondary"> شماره تماس: </span>
                    <span>{{ ListZamen[2].Tel }}</span>
                  </div>
                  <div class="col-md-4 col-12">
                    <span class="text-secondary"> شماره همراه: </span>
                    <span>{{ ListZamen[2].Mobile }}</span>
                  </div>
                  <div class="colmd-6 col-12">
                    <span class="text-secondary"> آدرس: </span>
                    <span>{{ ListZamen[2].Adres }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row border-right border-danger mt-3 mx-3" style="border-right: 3px solid #dc3545 !important">
              <div class="col-12 m-2 border-bottom">
                <h6>مشخصات فایلها</h6>
              </div>
              <div v-if="attachment == null" class="col-12">
                <h6 v-if="$session.get('CustCode') == 868 && FileHokm868 == null" class="text-danger">فایل حکم کارگزینی
                  بارگذاری نشده</h6>
                <!-- <h6 v-else class="">
                  <div class="row">
                    <div class="col-md-6 col-12">
                      <span class="text-secondary">نام فایل: </span>
                      <span>{{ FileHokm868.name }}</span>
                    </div>
                    <div class="col-md-6 col-12">
                      <span class="text-secondary">حجم فایل: </span>
                      <span>{{ FileHokm868.size / 1000000 }} Mb</span>
                    </div>
                  </div>
                </h6> -->

                <h6 v-if="$session.get('CustCode') == 868 && FileZamenanat868 == null" class="text-danger">فایل ضمانت
                  بارگذاری نشده</h6>
                <!-- <h6 v-else class="">
                  <div class="row">
                    <div class="col-md-6 col-12">
                      <span class="text-secondary">نام فایل: </span>
                      <span>{{ FileZamenanat868.name }}</span>
                    </div>
                    <div class="col-md-6 col-12">
                      <span class="text-secondary">حجم فایل: </span>
                      <span>{{ FileZamenanat868.size / 1000000 }} Mb</span>
                    </div>
                  </div>
                </h6> -->

                <h6 v-if="$session.get('CustCode') == 868 && FileGhardad868 == null" class="text-danger">فایل قرارداد
                  بارگزاری نشده</h6>
                <!-- <h6 v-else class="">
                  <div class="row">
                    <div class="col-md-6 col-12">
                      <span class="text-secondary">نام فایل: </span>
                      <span>{{ FileGhardad868.name }}</span>
                    </div>
                    <div class="col-md-6 col-12">
                      <span class="text-secondary">حجم فایل: </span>
                      <span>{{ FileGhardad868.size / 1000000 }} Mb</span>
                    </div>
                  </div>
                </h6> -->

                <h6 v-if="$session.get('CustCode') != 868" class="text-danger">فایلی بارگزاری نشده</h6>
              </div>
              <div v-else class="col-12">
                <div class="row">
                  <div class="col-md-6 col-12">
                    <span class="text-secondary">نام فایل: </span>
                    <span>{{ attachment.name }}</span>
                  </div>
                  <div class="col-md-6 col-12">
                    <span class="text-secondary">حجم فایل: </span>
                    <span>{{ attachment.size / 1000000 }} Mb</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row my-3">
              <div class="col-md-4 col-12"></div>
              <div class="col-md-4 col-12"></div>
              <div class="col-md-4 col-12">
                <button @click="FinalSubmit" class="btn btn-success w-100 NetPa-btn">ثبت نهایی درخواست</button>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template slot="content" v-else>
        <div class="row" style="font-size: large !important;">
          <h4>
            قوانین و مقررات دریافت وام
          </h4>

          <p>
            اظهار مینمایم که ذیحسابی سازمان خبرگزاری جمهوری اسلامی وکالت بلاعزل دارد معادل مبلغ وام پرداختی به انضمام
            کارمزد و هزینه های مزبور را بر اساس رقم و تعداد اقساطی که از سوی شرکت تعاونی به ذیحسابی اعلام میشود از حقوق
            و سایر مزایا و مطالبات اینجانب کسر و به حساب شرکت تعاونی واریز نماید. در ضمن متعهد می شوم چنانچه به هر دلیلی
            همکاری خود را با سازمان خبرگزاری جمهوری اسلامی اعم از دائم یا موقت (شامل مرخصی بدون حقوق ،آموزش، ماموریت و
            سایر موارد )قطع نمایم ضمن اعلام به شرکت ، کل مبلغ وام را یکجا تسویه نمایم و همچنین شرکت مختار است در صورت
            عدم دسترسی از ضامنین کسر نماید
          </p>

          <div class="d-flex">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value="" id="flexCheckIndeterminate"
                v-model="isAcceptSharaytVam" />
              <label class="form-check-label mx-3" for="flexCheckIndeterminate">
                قوانین و مقررات را مطلاعه نموده و قبول دارم
              </label>
            </div>

          </div>
          <div class="d-flex flex-row justify-content-end w-100 m-3">
            <button :disabled="!isAcceptSharaytVam" class="btn btn-success NetPa-btn" style="width: 25%;" @click="()=> showGhavaninVam = false">مرحله بعد
            </button>
          </div>


        </div>
      </template>
    </net-pa-card>

    <modal-custom>
      <template v-slot:ContentModalOrange>
        <div class="container-fluid">
          <div v-if="!AtachVam" class="row">
            <div class="col-12 col-md-6 p-2">
              <input type="text" placeholder="نام نام خانوادگی" class="form-control"
                v-model="ZamenToInsert.NameFamily" />
            </div>
            <div class="col-12 col-md-6 p-2">
              <input type="text" placeholder="نام پدر" class="form-control" v-model="ZamenToInsert.Pedar" />
            </div>
            <div class="col-12 col-md-6 p-2">
              <input type="text" placeholder="شغل" class="form-control" v-model="ZamenToInsert.Job" />
            </div>
            <!-- <div class="col-12 col-md-6 p-2">
                            <input type="text" placeholder="شغل " class="form-control" v-model="ZamenToInsert.NameFamily">
                        </div> -->
            <div class="col-12 col-md-6 p-2">
              <input type="number" placeholder="تلفن ثابت" class="form-control text-left" v-model="ZamenToInsert.Tel" />
            </div>
            <div class="col-12 col-md-6 p-2">
              <input type="number" placeholder="تلفن همراه" class="form-control text-left"
                v-model="ZamenToInsert.Mobile" />
            </div>
            <div class="col-12 p-2 col-md-12">
              <textarea type="text" class="form-control" v-model="ZamenToInsert.Adres"> </textarea>
            </div>
            <div class="col-md-4"></div>
            <div class="col-md-4">
              <button class="btn btn-primary NetPa-btn w-100" data-dismiss="modal">ثبت ضامن</button>
            </div>
            <div class="col-md-4"></div>
          </div>
          <div v-else class="row">
            <div class="col-12 alert alert-warning">جدول امتیازات وام شما به صورت زیر می باشد</div>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">First</th>
                  <th scope="col">Last</th>
                  <th scope="col">Handle</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">1</th>
                  <td>Mark</td>
                  <td>Otto</td>
                  <td>@mdo</td>
                </tr>
                <tr>
                  <th scope="row">2</th>
                  <td>Jacob</td>
                  <td>Thornton</td>
                  <td>@fat</td>
                </tr>
                <tr>
                  <th scope="row">3</th>
                  <td>Larry</td>
                  <td>the Bird</td>
                  <td>@twitter</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </template>
    </modal-custom>
  </div>
</template>
<script>
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'
import ModalCustom from '../Tools/ModalCustom.vue'

export default {
  components: { NetPaCard, ModalCustom },

  data() {
    return {
      isAcceptSharaytVam: false,
      showGhavaninVam: false,
      TblNoeId: null,
      NahveVarizDetail: null,
      AtachVam: false,
      nahvepardakht: 4015,
      DataAxiosTaahodat: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'ListTaahodat',
        Token: this.$session.get('TokenNetPa'),
      },
      DataAxiosAzaHesab: {
        ArryfildValue: '',
        Method: 'Get',
        Action: 'AzaHesab',
        Token: this.$session.get('TokenNetPa'),
      },
      ListTaahodat: [],
      ListAzaHesab: [],
      DataAxiosGetNoeVam: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'RequestVam',
        Token: this.$session.get('TokenNetPa'),
      },
      DataActionVamCondition: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'VamCondition',
        Token: this.$session.get('TokenNetPa'),
      },
      DataActionNoePolicy: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'NoePolicy',
        Token: this.$session.get('TokenNetPa'),
      },
      Vamha: [],
      divToShow: 1,
      SelectedVam: {},
      vamDetail: {
        Mablaghghest: 0,
        TedadGhest: 24,
        MablaghVam: 0,
        NeedData: '',
      },
      ListZamen: [
        {
          Adres: '',
          Mobile: '',
          Tel: '',
          Pedar: '',
          CodeMeli: '',
          NameFamily: '',
          Job: '',
          Id: null,
        },
        {
          Adres: '',
          Mobile: '',
          Tel: '',
          Pedar: '',
          CodeMeli: '',
          NameFamily: '',
          Job: '',
          Id: null,
        },
        {
          Adres: '',
          Mobile: '',
          Tel: '',
          Pedar: '',
          CodeMeli: '',
          NameFamily: '',
          Job: '',
          Id: null,
        },
      ],
      ZamenToInsert: {},
      ListCodeMeli: ['', '', ''],
      attachment: null,
      FileHokm868: null,
      FileZamenanat868: null,
      FileGhardad868: null,
      needVamId: 0,
    }
  },
  mounted() {
    this.vamDetail.NeedData = this.$GetJalaliDate()
    this.GetNoeVam()

    if (this.$session.get('CustCode') == 643) {
      this.showGhavaninVam = true
    }

  },
  methods: {

    GetNoeVam() {
      var formdata = new FormData()
      formdata.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      this.DataAxiosGetNoeVam.ArryfildValue = formdata
      this.$PostFormData(this.DataAxiosGetNoeVam).then((data) => {
        this.Vamha = data
      })
    },
    selectCurent(data, number) {
      var headers = document.getElementsByClassName('hoverHeader')
      for (let index = 0; index < headers.length; index++) {
        const element = headers[index]
        element.classList.remove('current')
      }
      if (data.target) {
        data.target.parentNode.classList.add('current')
      } else {
        data.parentNode.classList.add('current')
      }
      this.divToShow = number
    },
    seLectVam(data) {     
      var formdata = new FormData()
      formdata.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      formdata.append('wwwtblNoeId', data.id)
      this.TblNoeId = data.id
      this.DataActionVamCondition.ArryfildValue = formdata
      this.DataActionNoePolicy.ArryfildValue = formdata
      this.$PostFormData(this.DataActionVamCondition).then((res) => {
        this.$store.state.loading = true
        switch (res.id) {
          case 0:
            this.$PostFormData(this.DataActionNoePolicy).then((result) => {
              if (result.result == 'SUCCESS') {
                this.SelectedVam = data
                this.vamDetail.MablaghVam = this.$Comma3ragham(data.mablaghVam)
                if (this.$session.get('CustCode') == 868 && data.tedadGhestVam == 0) {
                  this.vamDetail.TedadGhest = 24
                } else {
                  this.vamDetail.TedadGhest = data.tedadGhestVam
                }
                this.vamDetail.Mablaghghest = data.mablaghVam > 0 ? Math.floor(Number(data.mablaghVam) / Number(data.tedadGhestVam)) : 0
              } else {
                this.$mySweetDefault('هشدار', result.result, 'warning', 2000)
              }
            })
            break
          case 1:
            this.$mySweetDefault('هشدار', 'سابقه عضویت شما جهت درخواست وام کافی نمیباشد.', 'warning', 2000)
            break
          case 2:
            this.$mySweetDefault('هشدار', 'تعداد تسهیلات دریافتی شما بیش از حد مجاز میباشد.', 'warning', 2000)
            break
          case 3:
            this.$mySweetDefault('هشدار', 'سقف بودجه ماهیانه به اتمام رسیده است.', 'warning', 2000)
            break

          case 5:
            this.$mySweetDefault('هشدار', 'موجودی حساب شما جهت درخواست تسهیلات کمتر از سقف تایید شده میباشد.', 'warning', 2000)
            break
          case 6:
            this.$mySweetDefault('هشدار', 'دریافت این نوع تسهیلات برای حوزه و یا نوع عضویت شما فعال نمیباشد.', 'warning', 2000)
            break
          case 7:
            this.$mySweetDefault('هشدار', 'به علت بدهی قبلی از این نوع تسهیلات شما مجاز به ثبت درخواست نمیباشید.', 'warning', 2000)
            break
          case 8:
            this.$mySweetDefault('هشدار', 'این تسهیلات پیش از این توسط شما درخواست داده شده است.', 'warning', 2000)
            break
          default:
            this.$mySweetDefault('خطا', 'پاسخی از سرور دریافت نشد.', 'error', 2000)
        }
        this.$store.state.loading = false
      })
    },
    nextPage(number) {
      // console.log("@@", number);
      if (number == 2) {
        const formData = new FormData()
        formData.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
        formData.append('wwwtblSarfaslTypeId', 2)
        this.DataAxiosTaahodat.ArryfildValue = formData
        this.$PostFormData(this.DataAxiosTaahodat).then((data) => {
          this.ListTaahodat = data
        })

        this.DataAxiosAzaHesab.ArryfildValue = { Id: this.$session.get('UserInfoNetPa').wwwtblAzaId }
        this.$GetData_Header(this.DataAxiosAzaHesab).then((data) => {
          this.ListAzaHesab = data
        })
      }

      if (number == 3 && (this.vamDetail.Mablaghghest == 0 || this.vamDetail.MablaghVam == 0)) {
        this.$mySweetDefault('هشدار', 'مبلغ وام و یا قسط آن نمیتواند صفر باشد.', 'warning', 2000)
      } else if (number == 3 && this.vamDetail.TedadGhest == 0) {
        this.$mySweetDefault('هشدار', 'تعداد قسط نمیتواند خالی باشد', 'warning', 2000)
      } else if (number == 3) {
        if (this.$session.get('CustCode') == 9) {
          this.cusCode9_VamRules()
        } else {
          this.selectCurent(document.getElementById('head' + number), number)
        }
      } else {
        this.selectCurent(document.getElementById('head' + number), number)
      }
    },
    calculateMablaghghest(e) {
      // this.vamDetail.TedadGhest = this.vamDetail.TedadGhest == 0 ? 1 : this.vamDetail.TedadGhest
      if (this.$session.get('CustCode') == 868) {
        var formdata = new FormData()
        formdata.append('wwwtblNoeId', this.SelectedVam.id)
        formdata.append('MabDarkhastVam', Number(this.vamDetail.MablaghVam.replace(/,/g, '')))
        formdata.append('TedadGhest', this.vamDetail.TedadGhest)
        formdata.append('TarixDarkhast', this.vamDetail.NeedData)
        var DataAxios = {
          ArryfildValue: formdata,
          Method: 'Post',
          Action: 'InsNewVam/CalcKarmozd',
          Token: this.$session.get('TokenNetPa'),
        }
        this.$PostFormData(DataAxios).then((res) => {
          this.vamDetail.Mablaghghest = (res.data[0].karmozdBimeSood + Number(this.vamDetail.MablaghVam.replace(/,/g, ''))) / this.vamDetail.TedadGhest
          this.vamDetail.Mablaghghest = Math.round(this.vamDetail.Mablaghghest)
          this.vamDetail.Mablaghghest = this.vamDetail.Mablaghghest + ''
          this.vamDetail.Mablaghghest = Number(this.vamDetail.Mablaghghest.replace(/\d{4}$/, '0000'))
        })
      } else {
        if (this.vamDetail.TedadGhest == 0) {
          this.vamDetail.Mablaghghest = 0
        } else {
          this.vamDetail.Mablaghghest = Number(this.vamDetail.MablaghVam.replaceAll(/,/g, '')) > 0 ? Number(this.vamDetail.MablaghVam.replaceAll(/,/g, '')) / this.vamDetail.TedadGhest : 0
        }
      }
    },

    cusCode9_VamRules() {
      let request = {
        Amount: this.vamDetail.MablaghVam.replaceAll(',', ''),
        NoeId: this.TblNoeId,
        TedadGhest: this.vamDetail.TedadGhest,
      }
      this.$PostData_new('VamCondition/CusCode9_VamRules', 'post', request).then((res) => {
        if (res.isSuccess == true) {
          this.selectCurent(document.getElementById('head' + 3), 3)
        } else {
          if (res.data != null) {
            let maxVam = this.$Comma3ragham(res.data)
            let messge = res.message + maxVam + ' است'
            this.$mySweetDefault('هشدار', messge, 'warning')
          } else {
            this.$mySweetDefault('هشدار', res.message, 'warning')
          }
          return
        }
      })
    },
    GetZament(number) {
      if (this.$session.get('UserInfoNetPa').codeMeli.trim() == this.ListCodeMeli[number]) {
        this.$mySweetDefault('خطا', 'شما کد ملی خود را وارد کرده اید', 'error', 2000)
        return
      }

      if (number == 0) {
        if (this.ListCodeMeli[1] == this.ListCodeMeli[0]) {
          this.ListCodeMeli[0] = ''
          this.$mySweetDefault('هشدار', 'ضامن تکراری است', 'warning', 2000)
          this.ListZamen[number].Tel = ''
          this.ListZamen[number].Pedar = ''
          this.ListZamen[number].NameFamily = ''
          this.ListZamen[number].Mobile = ''
          this.ListZamen[number].Adres = ''
          this.ListZamen[number].Id = null
          this.ListZamen[number].CodeMeli = ''
          return
        }
        if (this.ListCodeMeli[2] == this.ListCodeMeli[0]) {
          this.ListCodeMeli[0] = ''
          this.ListZamen[number].Tel = ''
          this.ListZamen[number].Pedar = ''
          this.ListZamen[number].NameFamily = ''
          this.ListZamen[number].Mobile = ''
          this.ListZamen[number].Adres = ''
          this.ListZamen[number].Id = null
          this.ListZamen[number].CodeMeli = ''
          this.$mySweetDefault('هشدار', 'ضامن تکراری است', 'warning', 2000)
          return
        }
      }
      if (number == 1) {
        if (this.ListCodeMeli[0] == this.ListCodeMeli[1]) {
          this.ListCodeMeli[1] = ''
          this.$mySweetDefault('هشدار', 'ضامن تکراری است', 'warning', 2000)
          this.ListZamen[number].Tel = ''
          this.ListZamen[number].Pedar = ''
          this.ListZamen[number].NameFamily = ''
          this.ListZamen[number].Mobile = ''
          this.ListZamen[number].Adres = ''
          this.ListZamen[number].Id = null
          this.ListZamen[number].CodeMeli = ''
          return
        }
        if (this.ListCodeMeli[2] == this.ListCodeMeli[1]) {
          this.ListCodeMeli[1] = ''
          this.$mySweetDefault('هشدار', 'ضامن تکراری است', 'warning', 2000)

          this.ListZamen[number].Tel = ''
          this.ListZamen[number].Pedar = ''
          this.ListZamen[number].NameFamily = ''
          this.ListZamen[number].Mobile = ''
          this.ListZamen[number].Adres = ''
          this.ListZamen[number].Id = null
          this.ListZamen[number].CodeMeli = ''
          return
        }
      }
      if (number == 2) {
        if (this.ListCodeMeli[0] == this.ListCodeMeli[2]) {
          this.ListCodeMeli[2] = ''
          this.$mySweetDefault('هشدار', 'ضامن تکراری است', 'warning', 2000)
          this.ListZamen[number].Tel = ''
          this.ListZamen[number].Pedar = ''
          this.ListZamen[number].NameFamily = ''
          this.ListZamen[number].Mobile = ''
          this.ListZamen[number].Adres = ''
          this.ListZamen[number].Id = null
          this.ListZamen[number].CodeMeli = ''
          return
        }
        if (this.ListCodeMeli[1] == this.ListCodeMeli[2]) {
          this.ListCodeMeli[2] = ''
          this.$mySweetDefault('هشدار', 'ضامن تکراری است', 'warning', 2000)
          this.ListZamen[number].Tel = ''
          this.ListZamen[number].Pedar = ''
          this.ListZamen[number].NameFamily = ''
          this.ListZamen[number].Mobile = ''
          this.ListZamen[number].Adres = ''
          this.ListZamen[number].Id = null
          this.ListZamen[number].CodeMeli = ''
          return
        }
      }

      if (this.ListCodeMeli[number].length < 10) {
        this.$mySweetDefault('خطا', ' طول کد ملی نمیتواند کمتر از 10 رقم باشد', 'error', 2000)
      } else {
        var DataAxiosGetZament = {
          ArryfildValue: '',
          Method: 'Post',
          Action: 'GetZamenByMelli2',
          Token: this.$session.get('TokenNetPa'),
        }
        var formdata = new FormData()
        formdata.append('wwwtblShobeId', this.$session.get('UserInfoNetPa').wwwtblShobeId)
        formdata.append('CodeMeli', this.ListCodeMeli[number])
        DataAxiosGetZament.ArryfildValue = formdata
        this.$PostFormData(DataAxiosGetZament).then((data) => {
          if (data != null) {
            if (data.success && data.success == 'Fail') {
              this.$mySweetDefault('خطا', data.message, 'error', 3500)
            } else if (data.mandeZemanat != null) {
              if (data.mandeZemanat >= Number(this.vamDetail.MablaghVam.replace(/\,/g, ''))) {
                //مبلغ وام کمتر از سقف ضمانت می باشد
                this.ListZamen[number].Tel = data.tel
                this.ListZamen[number].Pedar = data.pedar
                this.ListZamen[number].NameFamily = data.nameFamily
                this.ListZamen[number].Mobile = data.mobile
                this.ListZamen[number].Adres = data.adres
                this.ListZamen[number].Id = data.id
                this.ListZamen[number].CodeMeli = this.ListCodeMeli[number]
              } else {
                this.$mySweetDefault('خطا', 'ضامن وارد شده به سقف ضمانت خود رسیده ، لطفا ضامن دیگری انتخاب نمایید', 'error', 3500)
              }
            } else {
              this.ListZamen[number].Tel = data.tel
              this.ListZamen[number].Pedar = data.pedar
              this.ListZamen[number].NameFamily = data.nameFamily
              this.ListZamen[number].Mobile = data.mobile
              this.ListZamen[number].Adres = data.adres
              this.ListZamen[number].Id = data.id
              this.ListZamen[number].CodeMeli = this.ListCodeMeli[number]
            }
          } else {
            this.ZamenToInsert = this.ListZamen[number]
            this.$mySweetDefault('هشدار', 'فرد مورد نظر در بین مشتریان ' + this.$session.get('IsTaavoniEtebar') == true ? 'تعاونی اعتبار' : 'صندوق' + ' یافت نشد. مشخصات ضامن را به صورت دستی وارد کنید.', 'warning', 3500)
            document.getElementById('ZamenModal').click()
          }
        })
      }
    },
    clickUploader() {
      document.getElementById('attachmentUploader').click()
    },
    changeattach(e) {
     const file = e.target.files[0]
    if (!file) return

    const allowedExtensions = ['gif', 'jpg', 'jpeg', 'png', 'zip', 'rar', 'pdf']
    const fileExtension = file.name.split('.').pop().toLowerCase()
    if (!allowedExtensions.includes(fileExtension)) {
      this.$mySweetDefaultTost(
        'فرمت فایل مجاز نیست',
        `فرمت ${fileExtension} پشتیبانی نمی‌شود.`,
        'error',
        3000
      )
      e.target.value = ''
      return
    }
      this.attachment = document.getElementById('attachmentUploader').files[0]
      if (this.attachment.size / 1000000 > 5) {
        this.$mySweetDefaultTost('هشدار', 'حجم فایل نمیتواند بیش از 5 مگابایت باشد', 'error', 2000)
        document.getElementById('attachmentUploader').value = null
        this.attachment = null
      }
    },
    FinalSubmit() {
      var formdata = new FormData()

      if (this.ListCodeMeli[0] == null) {
        this.$mySweetDefault('عملیات ناموفق', 'وارد کردن ضامن اول اجباری میباشد', 'error', 2500)
        return
      }

      this.vamDetail.MablaghVam = this.vamDetail.MablaghVam.replaceAll(',', '')

      formdata.append('NahveVarizDetail', this.NahveVarizDetail)
      formdata.append('WwwtblcomboIdNahveVarizGrp7', this.nahvepardakht)
      formdata.append('wwwtblAzaId', this.$session.get('UserInfoNetPa').wwwtblAzaId)
      formdata.append('RequestTarix', this.$store.state.JalaliDate)
      formdata.append('Mablagh', this.vamDetail.MablaghVam)
      formdata.append('MablaghTavanaiePardakht', this.vamDetail.MablaghVam)
      formdata.append('TedadGhest', this.vamDetail.TedadGhest)
      formdata.append('NeedTarix', this.vamDetail.NeedData)
      formdata.append('CodeMeliZamenAsli', this.ListCodeMeli[0])
      formdata.append('CodeMeliZamenFarei', this.ListCodeMeli[1])
      formdata.append('NameFamilyZamenAsli', this.ListZamen[0].NameFamily == null ? '' : this.ListZamen[0].NameFamily)
      formdata.append('CodeMeliMoaref', this.ListCodeMeli[2])
      formdata.append('PedarZamenAsli', this.ListZamen[0].Pedar == null ? '' : this.ListZamen[0].Pedar)
      formdata.append('TelZamenAsli', this.ListZamen[0].Tel == null ? '' : this.ListZamen[0].Tel)
      formdata.append('MobileZamenAsli', this.ListZamen[0].Mobile == null ? '' : this.ListZamen[0].Mobile)
      formdata.append('AdresZamenAsli', this.ListZamen[0].Adres == null ? '' : this.ListZamen[0].Adres)
      formdata.append('MobileZamenFarei', this.ListZamen[1].Mobile == null ? '' : this.ListZamen[1].Mobile)
      formdata.append('AdresZamenFarei', this.ListZamen[1].Adres == null ? '' : this.ListZamen[1].Adres)
      formdata.append('TelZamenFarei', this.ListZamen[1].Tel == null ? '' : this.ListZamen[1].Tel)
      formdata.append('PedarZamenFarei', this.ListZamen[1].Pedar == null ? '' : this.ListZamen[1].Pedar)
      formdata.append('NameFamilyZamenFarei', this.ListZamen[1].NameFamily == null ? '' : this.ListZamen[1].NameFamily)
      formdata.append('ShoghlZamenAsli', this.ListZamen[0].Job == null ? '' : this.ListZamen[0].Job)
      formdata.append('ShoghlZamenFarei', this.ListZamen[1].Job == null ? '' : this.ListZamen[1].Job)
      formdata.append('ShoglMoaref', this.ListZamen[2].Job == null ? '' : this.ListZamen[2].Job)
      formdata.append('AdresMoaref', this.ListZamen[2].Adres == null ? '' : this.ListZamen[2].Adres)
      formdata.append('MobileMoaref', this.ListZamen[2].Mobile == null ? '' : this.ListZamen[2].Mobile)
      formdata.append('TellMoaref', this.ListZamen[2].Tel == null ? '' : this.ListZamen[2].Tel)
      formdata.append('PedarMoaref', this.ListZamen[2].Pedar == null ? '' : this.ListZamen[2].Pedar)
      formdata.append('NameFamiliMoaref', this.ListZamen[2].NameFamily == null ? '' : this.ListZamen[2].NameFamily)
      formdata.append('AzaIdMoaref', this.ListZamen[2].Id == null ? '' : this.ListZamen[2].Id)
      formdata.append('AzaIdZamenFarei', this.ListZamen[1].Id == null ? '' : this.ListZamen[2].Id)
      formdata.append('AzaIdZamen', this.ListZamen[0].Id == null ? '' : this.ListZamen[0].Id)
      formdata.append('IsTaeidVam', 0)
      formdata.append('wwwtblNoeId', this.SelectedVam.id)
      if (this.attachment) {
        formdata.append('file', this.attachment)
      }
      var DataAxiosSubmit = {
        ArryfildValue: formdata,
        Method: 'Post',
        Action: 'InsNewVam',
        Token: this.$session.get('TokenNetPa'),
      }

      this.$PostFormData(DataAxiosSubmit)
        .then((data) => {
          if (data.success == 'SUCCESS') {
            this.needVamId = data.needVamId
            //اگر needVamId پر بود فایل هارو بفرستیم
            if (this.$session.get('CustCode') == 868) {
              if (this.FileHokm868 != null && this.FileZamenanat868 != null && this.FileGhardad868 != null) {
                var formdataAtach = new FormData()
                formdataAtach.append('needVamId', this.needVamId)
                formdataAtach.append('FileHokm868', this.FileHokm868)
                formdataAtach.append('FileZamenanat868', this.FileZamenanat868)
                formdataAtach.append('FileGhardad868', this.FileGhardad868)
                var axios = { Method: 'POST', Action: 'InsNewVam/Atachment868', ArryfildValue: formdataAtach, Token: this.$session.get('TokenNetPa') }
                this.$PostFormData(axios).then((res) => { })
              } else {
                this.$mySweetDefaultTost('خطا', 'لطفا تمامی فایل های خواسته شده را آپلود نمایید ', 'warning', 2000)
              }
            }
            this.$mySweetDefault('عملیات موفق', 'درخواست وام شما با کد رهگیری ' + data.codeRahgiri + ' در سیستم ثبت شد.', 'success', 2500)
            this.$router.push('loanFollowup')
          } else {
            this.needVamId = 0
            this.$mySweetDefault('عملیات ناموفق', 'درخواست شما در سیستم ثبت نشد.', 'warning', 2500)
          }
        })
        .catch((error) => {
          this.$mySweetDefault('عملیات ناموفق', 'مشکلی بوجود آمده است. دوباره تلاش کنید', 'error', 2500)
          this.needVamId = 0
          console.warn(error)
        })
    },
    CheckupSaghfVam(e) {
      if (e.target.value.replace(/,/g, '') > this.SelectedVam.mabTaeenSaghfVam) {
        this.vamDetail.MablaghVam = this.$Comma3ragham(this.SelectedVam.mabTaeenSaghfVam)
        this.calculateMablaghghest()
        this.$mySweetDefault('خطا در مبلغ تسهیلات', ' سقف مبلغ تسهیلات ' + this.$Comma3ragham(this.SelectedVam.mabTaeenSaghfVam) + ' می باشد و نمی توانید بیشتر از این مبلغ درخواست تسهیلات کنید ', 'error', 3000)
      }
    },
    OpenUploader(Type) {
      // Type 1= ExcelFile, Type 2=JsonFile
      if (Type == 1) {
        document.getElementById('FileHokm').click()
      }
      if (Type == 2) {
        document.getElementById('FileZemanat').click()
      }
      if (Type == 3) {
        document.getElementById('FileGhrardad').click()
      }
    },
    UploadFile(e, Type, FileUploaderId) {
      const file = e.target.files[0]
    if (!file) return

    const allowedExtensions = ['gif', 'jpg', 'jpeg', 'png', 'zip', 'rar', 'pdf']
    const fileExtension = file.name.split('.').pop().toLowerCase()
    if (!allowedExtensions.includes(fileExtension)) {
      this.$mySweetDefaultTost(
        'فرمت فایل مجاز نیست',
        `فرمت ${fileExtension} پشتیبانی نمی‌شود.`,
        'error',
        3000
      )
      e.target.value = ''
      return
    }
      if (e.srcElement.files[0].size / 1000000 > 3) {
        this.$mySweetDefaultTost('هشدار', 'حجم فایل نمیتواند بیش از 3 مگابایت باشد', 'error', 2000)
        document.getElementById(FileUploaderId).value = null
      } else {
        if (Type == 1) {
          this.FileHokm868 = e.srcElement.files[0]
        }
        if (Type == 2) {
          this.FileZamenanat868 = e.srcElement.files[0]
        }
        if (Type == 3) {
          this.FileGhardad868 = e.srcElement.files[0]
        }
      }
    },
  },
  updated() {
    this.vamDetail.Mablaghghest = Math.floor(this.vamDetail.Mablaghghest)
    this.$PutCommatoInput()
    // this.vamDetail.Mablaghghest ==this.$Comma3ragham(this.vamDetail.Mablaghghest);
  },
}
</script>
<style scoped>
.hoverHeader:hover {
  font-weight: bold;
  color: darkorchid;
  background: rgb(224, 221, 226);
  cursor: pointer;
  transition: all 0.5s ease-in;
}

/* .hoverHeader{
    border-radius: 11% 89% 12% 88% / 94% 0% 100% 6%  ;
    -webkit-box-shadow: 0px 0px 15px -6px rgba(202,202,202,0.72); 
    box-shadow: 0px 0px 15px -6px rgba(202,202,202,0.72);

} */
.hoverHeader.current {
  font-weight: bold;
  color: #435ebe;
  background: #dee3f5;
  cursor: pointer;
  transition: all 0.5s ease-in;
}

.blueback {
  width: 100%;
  min-height: 80px;
  background: rgb(184, 218, 235);
  border: 2px dotted #3161e7;
  border-radius: 15px;
}

.yellowback {
  width: 100%;
  min-height: 80px;
  background: rgb(208, 224, 118);
  border: 2px dotted #929c04;
  border-radius: 15px;
}

.Uploader {
  width: 100%;
  height: 100%;
  border: 2px dashed #0c6ec9 !important;
  border-radius: 8px;
}

.Uploader:hover .fa-file-import {
  color: #0c6ec9 !important;
  transition: 0.3s;
}
</style>
